/**
 * @rc-component/portal useScrollLocker가 head에 주입하는
 * `html body { width: calc(100% - Npx) }` 규칙만 제거한다.
 */
const LOCKER_WIDTH_RULE =
	/\s*width\s*:\s*calc\s*\(\s*100%\s*-\s*\d+(?:\.\d+)?px\s*\)\s*;?/gi;

function isScrollLockStyle(styleEl) {
	if (!styleEl?.textContent?.includes("html body")) {
		return false;
	}
	const id = styleEl.id || "";
	if (id.startsWith("rc-util-locker")) {
		return true;
	}
	// rc-util dynamicCSS 마커 + locker 본문
	return (
		styleEl.hasAttribute("data-rc-order") &&
		styleEl.textContent.includes("overflow-y: hidden")
	);
}

function scrubLockStyleElement(styleEl) {
	if (!isScrollLockStyle(styleEl)) {
		return;
	}
	const next = styleEl.textContent.replace(LOCKER_WIDTH_RULE, "");
	if (next !== styleEl.textContent) {
		styleEl.textContent = next;
	}
}

function scrubAllLockStyles() {
	document.querySelectorAll("style").forEach(scrubLockStyleElement);
}

function clearBodyInlineScrollLockWidth() {
	if (!document.body) {
		return;
	}
	const w = document.body.style.width;
	if (w && /calc\s*\(\s*100%\s*-/.test(w)) {
		document.body.style.width = "";
	}
}

export default function installModalScrollLockFix() {
	if (typeof document === "undefined") {
		return;
	}

	const run = () => {
		scrubAllLockStyles();
		clearBodyInlineScrollLockWidth();
	};

	run();

	const observer = new MutationObserver(run);
	observer.observe(document.head, { childList: true, subtree: true });
	observer.observe(document.body, {
		attributes: true,
		attributeFilter: ["class", "style"],
	});
}
